import { SSO_GROUPS_KEY_ID } from '@lucidlink/dto/validation';
import { AES_ENCRYPTION_ALGO_PARAMS, arrayToAesKey, base64ToArray, decryptWithRsaBlockCipher, encryptionKeyPairFromArray, verifyDecryptRsaBlockCipher, verifyPublicPrivateKeyPair, } from '@lucidlink/ts-crypto/crypto';
import { TimeCachedValue } from '#sdk/utils/time-cached-value.ts';
import { verifyWorkspaceCryptoTuple } from './crypto-utils';
import { InvalidCryptoError } from './workspace-crypto.error';
export class SsoCrypto {
    adminKeys;
    workspaceId;
    ssoCryptoData;
    logger;
    constructor(adminKeys, workspaceId, ssoCryptoData, logger) {
        this.adminKeys = adminKeys;
        this.workspaceId = workspaceId;
        this.ssoCryptoData = ssoCryptoData;
        this.logger = logger;
        this.logger = this.logger.child({ class: 'SsoCrypto' });
    }
    verifyAndGetSsoSecretKey() {
        return this.ssoSecretKey.get();
    }
    verifyAndGetSsoGroupKeys() {
        return this.ssoGroupKeys.get();
    }
    ssoSecretKey = new TimeCachedValue(async () => {
        const adminKeys = await this.adminKeys.get();
        const ssoSecretKeyArray = await verifyDecryptRsaBlockCipher(this.ssoCryptoData.seSsoSecretKeyByAdminKey, adminKeys);
        if (!ssoSecretKeyArray) {
            this.throwInvalidCrypto('SSO secret key signature is invalid');
        }
        return arrayToAesKey(ssoSecretKeyArray, AES_ENCRYPTION_ALGO_PARAMS);
    });
    ssoGroupKeys = new TimeCachedValue(async () => {
        const adminKeys = await this.adminKeys.get();
        const ssoGroupsPublicKeyArray = base64ToArray(this.ssoCryptoData.ssoGroupsPublicKey);
        const ssoGroupKeySignatureArray = base64ToArray(this.ssoCryptoData.sSsoGroupsPublicKeyByAdminKey);
        const isSsoGroupKeyVerified = await verifyWorkspaceCryptoTuple({
            id: SSO_GROUPS_KEY_ID,
            workspaceId: this.workspaceId,
            publicKey: ssoGroupsPublicKeyArray,
        }, ssoGroupKeySignatureArray, adminKeys.signPair.publicKey);
        if (!isSsoGroupKeyVerified) {
            this.throwInvalidCrypto('SSO groups public key signature is invalid');
        }
        const ssoGroupPrivateKeyArray = await decryptWithRsaBlockCipher(this.ssoCryptoData.eSsoGroupsPrivateKeyByAdminKey, adminKeys.encryptPair.privateKey);
        const ssoGroupKeys = await encryptionKeyPairFromArray(ssoGroupsPublicKeyArray, ssoGroupPrivateKeyArray);
        const isSsoGroupKeyPairVerified = await verifyPublicPrivateKeyPair(ssoGroupKeys);
        if (!isSsoGroupKeyPairVerified) {
            this.throwInvalidCrypto('SSO groups public and private keys do not match');
        }
        return ssoGroupKeys;
    });
    throwInvalidCrypto(errorText) {
        this.logger.error({ workspaceId: this.workspaceId }, errorText);
        throw new InvalidCryptoError(errorText);
    }
}
